import React from 'react';
import PropTypes from 'prop-types';
import { isUuid, isNumeric, createCustomPropType } from '../../../js/app/react/validators';

const AllPlanEditsCount = props => {
  const { clientId, goalId, numberOfEdits, setCurrentViewId } = props;
  return (
    <ul
      className={`active-edits-ul what-ifs-layout-header-plan-edits${
        numberOfEdits === 0 ? ' has-zero-plan-edits' : ''
      }`}
    >
      <li className="what-ifs-section active-edits">
        <button type="button" onClick={setCurrentViewId(clientId, goalId)} aria-expanded={false}>
          Applied What-Ifs<span>{numberOfEdits}</span>
        </button>
      </li>
    </ul>
  );
};

AllPlanEditsCount.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  numberOfEdits: PropTypes.number.isRequired,
  setCurrentViewId: PropTypes.func.isRequired,
};

export default AllPlanEditsCount;
